import { render, staticRenderFns } from "./ring.vue?vue&type=template&id=6afbf824&scoped=true&"
import script from "./ring.vue?vue&type=script&lang=js&"
export * from "./ring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afbf824",
  null
  
)

export default component.exports